module.exports = __webpack_public_path__ + "img/solid-trinapps.a0cf2a46.png";